import useLocalStore from '../state/useLocalStore';
import { ITransactionType } from '../state/type';

const useTransactions = () => {
  const { transactions, setTransactions } = useLocalStore();

  const setTransactionsByCalc = ({
    transaction,
  }: {
    transaction: ITransactionType;
  }) => {
    const chainId = transaction.chainId;
    const items = transactions[chainId];

    const hisotrys = [transaction, ...(items ? items : [])];

    setTransactions({
      ...transactions,
      [chainId]: hisotrys.splice(0, 5),
    });
  };

  return {
    transactions,
    setTransactions: setTransactionsByCalc,
  };
};

export default useTransactions;
